import React from 'react';
import Switch from 'react-switch';

import { ISwitchToggleProps } from './SwitchToggle.types';

const SwitchToggle = ({
  id,
  checked = false,
  width = 44,
  height = 26,
  handleDiameter = 24,
  onColor,
  offColor,
  onChange,
  isDisabled = false,
}: ISwitchToggleProps): JSX.Element => {
  return (
    <Switch
      id={id}
      checked={checked}
      checkedIcon={false}
      uncheckedIcon={false}
      width={width}
      height={height}
      handleDiameter={handleDiameter}
      onColor={onColor}
      offColor={offColor}
      onChange={onChange}
      disabled={isDisabled}
    />
  );
};

export default SwitchToggle;
